import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0Zm-7.99 5.999a.049.049 0 0 1-.02 0 .21.21 0 0 1-.039-.013.853.853 0 0 1-.216-.142c-.216-.182-.496-.524-.775-1.082-.46-.92-.815-2.228-.925-3.762h3.93c-.11 1.534-.465 2.841-.925 3.762-.279.558-.56.9-.775 1.082a.853.853 0 0 1-.216.143.21.21 0 0 1-.038.012ZM9.966 7h-3.93c.11-1.534.465-2.841.925-3.762.279-.558.56-.9.775-1.082a.852.852 0 0 1 .216-.142A.215.215 0 0 1 8 2l.01.001a.215.215 0 0 1 .039.013c.04.016.113.054.216.142.216.182.496.524.775 1.082.46.92.815 2.228.925 3.762Zm2.004 2c-.098 1.577-.426 3.011-.914 4.165A6.005 6.005 0 0 0 13.917 9h-1.948Zm1.948-2H11.97c-.098-1.577-.426-3.011-.914-4.165A6.005 6.005 0 0 1 13.917 7ZM4.031 7c.098-1.577.426-3.011.914-4.165A6.005 6.005 0 0 0 2.083 7h1.948ZM2.083 9a6.005 6.005 0 0 0 2.862 4.165C4.457 12.011 4.13 10.577 4.031 9H2.083Z",
    fill: "currentColor"
  }));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Planet16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Planet16 = createIcon(IconComponent);